import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserPageTrackingService } from '../../../../shared/signalR/userPageTrackingService';
import { Subscription } from 'rxjs/Subscription';
import { UserConnection } from '../../../../shared/signalR/models/models';
import { TableColumnModel } from '../../../../shared/models/models';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { r } from '@angular/core/src/render3';

@Component({
  selector: 'app-user-page-tracking',
  templateUrl: './user-page-tracking.component.html',
  styleUrls: ['./user-page-tracking.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserPageTrackingComponent implements OnInit, OnDestroy {
  private changeFlagSubscription: Subscription;
  public columnMode = ColumnMode;
  public divisionUsers: UserConnection[] = [];
  public tableColumns: TableColumnModel[];
  public divisionUrl = "";


  constructor(
    public pageUserService: UserPageTrackingService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.tableColumns = [
      { name: '',             prop: 'initials',   width: 50 },
      { name: 'User Name',    prop: 'userName',   width: 100 },
      { name: 'Time Stamp',   prop: 'timestamp',  width: 200 },
      { name: 'Description',  prop: 'url',        width: 1000 },
    ];
    this.changeFlagSubscription = this.pageUserService.changeFlag$.subscribe(() => {
      this.updateTableList();
    });
    this.activatedRoute.data.subscribe(data => {
      this.divisionUrl = "";
      if (data.divisionId) {
        if(data.divisionId == 1){
          this.divisionUrl = "/fleet-manager";
        }
        if(data.divisionId == 3){
          this.divisionUrl = "/portal";
        }
      }
    })

  }

  ngOnDestroy() {
    if (this.changeFlagSubscription) {
      this.changeFlagSubscription.unsubscribe();
    }
  }

  public updateTableList(){
    this.divisionUsers = this.pageUserService.allUsers
      .filter(x => x.url.startsWith(this.divisionUrl))
      .map(user => ({ ...user }));
    this.divisionUsers.forEach(user => {
      user.url = user.url.slice(this.divisionUrl.length);
      user.backgroundColor = this.pageUserService.ensureDarkColor(user.initials)
    });
  }

  public getCellClass(cell){
    if(cell.column.prop == 'initials'){
      return ' d-flex justify-content-center align-items-center m-0 p-0 ';
    }
    return ' d-flex justify-content-start align-items-center m-0 p-0 ';
  }

  public redirectTo(value){
    window.open(this.divisionUrl + value, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/user-tracking/user-page-tracking/user-page-tracking.component.ts